"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyForRefundIneligibleUI = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var copy_1 = require("../../../copy");
var components_1 = require("./components");
var ApplyForRefundIneligibleUI = function (_a) {
    var reasonCode = _a.reasonCode;
    var _b = (0, core_1.useComponents)(), Margin = _b.Margin, Card = _b.Card;
    var _c = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _c.copy, Copy = _c.Copy;
    var messageMap = new Map([
        [
            'BalanceWouldNotExceedDirectDebitError',
            react_1.default.createElement(Copy, { copyKey: "balanceWouldNotExceedDirectDebitError", key: "balanceWouldNotExceedDirectDebitError" }),
        ],
        [
            'NoDirectDebitError',
            react_1.default.createElement(Copy, { copyKey: "noDirectDebitError", key: "noDirectDebitError" }),
        ],
        [
            'NO_ACTIVE_MANDATE',
            react_1.default.createElement(Copy, { copyKey: "noDirectDebitError", key: "noDirectDebit" }),
        ],
        [
            'RefundAlreadyRequestedError',
            react_1.default.createElement(Copy, { copyKey: "refundAlreadyRequestedError", key: "refundAlreadyRequestedError" }),
        ],
        [
            'PAYOUT_ALREADY_REQUESTED',
            react_1.default.createElement(Copy, { copyKey: "refundAlreadyRequestedError", key: "payoutAlreadyRequested" }),
        ],
        [
            'IsLossCustomerError',
            react_1.default.createElement(Copy, { copyKey: "isLossCustomerError", key: "isLossCustomerError" }),
        ],
        [
            'ACCOUNT_IN_LOSS',
            react_1.default.createElement(Copy, { copyKey: "isLossCustomerError", key: "accountInLoss" }),
        ],
        [
            'StaleMeterReadingError',
            react_1.default.createElement(Copy, { copyKey: "staleMeterReadingError", key: "staleMeterReadingError" }),
        ],
        [
            'NO_FRESH_METER_READING',
            react_1.default.createElement(Copy, { copyKey: "staleMeterReadingError", key: "staleMeterReading" }),
        ],
        [
            'BillingOnHoldError',
            react_1.default.createElement(Copy, { copyKey: "fallBackReasons", key: "fallBackReasons" }),
        ],
        ['BILLING_ON_HOLD', react_1.default.createElement(Copy, { copyKey: "fallBackReasons", key: "bilingOnHold" })],
        [
            'ExcessiveBalanceError',
            react_1.default.createElement(Copy, { copyKey: "fallBackReasons", key: "fallBackReasons" }),
        ],
    ]);
    var headingMap = new Map([
        ['RefundAlreadyRequestedError', copy('ineligibleReasonAlreadyRequested')],
        ['PAYOUT_ALREADY_REQUESTED', copy('ineligibleReasonAlreadyRequested')],
        ['BillingOnHoldError', copy('ineligibleError')],
        ['BILLING_ON_HOLD', copy('ineligibleError')],
        ['ExcessiveBalanceError', copy('ineligibleError')],
    ]);
    return (react_1.default.createElement(Margin, { bottom: 6 },
        react_1.default.createElement(Card, null,
            react_1.default.createElement(components_1.IneligibleForRefund, { heading: headingMap.get(reasonCode), message: messageMap.get(reasonCode) || '' }),
            react_1.default.createElement(components_1.EligibilityCriteria, { reasonCode: reasonCode }),
            reasonCode !== 'IsLossCustomerError' &&
                reasonCode !== 'ACCOUNT_IN_LOSS' ? (react_1.default.createElement(Margin, { bottom: 6 },
                react_1.default.createElement(Copy, { copyKey: "refundPolicyLink" }))) : null,
            react_1.default.createElement(components_1.Link, { reasonCode: reasonCode }))));
};
exports.ApplyForRefundIneligibleUI = ApplyForRefundIneligibleUI;
